export default {
    state: {
        searchSelectedDeveloper: null,
    },
    actions: {},
    mutations: {
        DEVELOPER_SEARCH_SELECTED: function (state, val) {
            state.searchSelectedDeveloper = val;
        }
    },
    getters: {}
};
